import React, { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import { CaretLeftOutlined } from '@ant-design/icons'

import { LoadingIndicator } from 'basecomps'
import { useGameNews } from 'data/hooks'

export const New = props => {

  const gameId = useParams().gameId || playmotiv.game.gameId
  const { news, parseContent } = useGameNews(gameId)
  const { newId } = useParams()
  const [ noticia, setNoticia ] = useState()

  useEffect(() => {

    setNoticia(news.find(n => n.ID === newId))

  }, [newId, news])

  return (
    <div className="game-new content">
      { noticia ? 
        <>
          <Link className="close-button" to={-1}><CaretLeftOutlined /> Volver</Link>
          { noticia.image && 
            <div className="image">
              <img src={ noticia.image } />
            </div>
          }
          <h1>{ noticia.post_title }</h1>
          <div>{ parseContent(noticia.post_content) }</div>
        </>
        :
        <LoadingIndicator text="Cargando la noticia ..." />
      }      
    </div>
  )
}
